<div class="wrapper">
  <mat-card class="notice">
    <h1 style="margin-bottom: 8px;">{{ getMessage('greeting') }} {{ userProfile ? userProfile.alias : '' }}</h1>
    <p class="mat-subheading-2">{{ getMessage('pendingApprovalSubtitle') }}</p>

    <p>{{ getMessage('pendingApprovalStep1') }}</p>
  </mat-card>
</div>
